"use strict";
/**
 * 통신 로그 조회 — 전문 단위 TCP 통신 기록(`comm_log`)을 화면에서 읽는 계약.
 *
 * 왜 있나: 이성진 소장이 지목한 3차 산출물이다 — "프로토콜 통신을 하다 보면 여러 가지 이유로
 * 버그나 멈춤 대기 이런 것들이 발견될 때가 있는데 그럴 때마다 로그값을 좀 분석을 해야 돼요.
 * 로그 분석을 좀 간편하게 할 수 있게끔." 현장에서 "왜 인증이 안 되나"를 답하는 창구다.
 *
 * 처음엔 **본사 전용**이었다(사용자 결정 2026-09-13) — `comm_log`에는 조직 컬럼이 없고, 가맹점을
 * 조인해 대리점으로 좁히면 진단에 필요한 행(CRC·LENGTH 실패, 미등록 단말의 인증 시도)이
 * 식별자가 비어 통째로 빠지기 때문이다. 2026-09-14 대표 요청으로 **3계층 개방**하되 비본사는
 * 소속이 확인되는 행만 보고, 어느 조직에도 안 붙는 행은 본사만 본다(`applyCommLogScope`).
 *
 * ── 1행 구조 (2026-10-01 대표 확정, B안) ────────────────────────────────────
 * 처음에는 전문 왕복 한 번에 IN·OUT **2행**이 쌓였다. 짝지을 키가 없어 "이 요청에 무엇으로
 * 답했나"를 한 줄로 읽을 수 없었고 행 수도 두 배였다. 지금은 **전문 1건 = 요청·응답 1행**이다
 * (`kind`가 `ROUNDTRIP`). 한쪽만 있는 사건(접속 거절·CRC 불일치·응답 전 NACK·강제 종료·
 * 재전송 초과·응답 전 연결 종료)은 `EVENT` 행으로, 요청 쪽이나 응답 쪽 컬럼만 채운다.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMM_LOG_SEARCH_MAX_ROWS = exports.COMM_LOG_SEARCH_STATUS_LABEL = exports.COMM_LOG_PLAIN_DAYS = exports.COMM_LOG_MAX_RANGE_DAYS = exports.COMM_LOG_DEFAULT_RANGE_DAYS = exports.TCP_SERVICE_CODES = exports.TCP_SERVICE_LABEL = exports.COMM_LOG_ENV_LABEL = exports.COMM_LOG_KINDS = exports.COMM_LOG_KIND_LABEL = void 0;
exports.tcpServiceLabel = tcpServiceLabel;
exports.COMM_LOG_KIND_LABEL = {
    ROUNDTRIP: '왕복',
    EVENT: '이벤트',
};
/** 필터 선택지·정렬용 (선언 순서 = 화면 표시 순서) */
exports.COMM_LOG_KINDS = Object.keys(exports.COMM_LOG_KIND_LABEL);
exports.COMM_LOG_ENV_LABEL = {
    PROD: '운영',
    TEST: '테스트',
};
/** 서비스 코드 → 한글 명칭. 서버(선언표·엑셀)와 화면(필터·그리드)이 **같은 한 벌**을 쓴다 */
exports.TCP_SERVICE_LABEL = {
    '0001': '버전 리스트 요청',
    '1001': '버전 리스트 응답',
    '0002': '펌웨어/프로그램 버전 정보 요청',
    '1002': '펌웨어/프로그램 버전 정보 응답',
    '0003': '펌웨어/프로그램 다운로드 요청',
    '1003': '펌웨어/프로그램 다운로드 응답',
    '0004': '파일 업로드 정보 요청',
    '1004': '파일 업로드 정보 응답',
    '0005': '파일 업로드 요청',
    '1005': '파일 업로드 응답',
    '0006': 'PAYVCAT 설정 정보 요청',
    '1006': 'PAYVCAT 설정 정보 응답',
    '0007': 'PAYVCAT 인증 요청',
    '1007': 'PAYVCAT 인증 응답',
    '0008': 'PAYVCAT 상태 확인 요청',
    '1008': 'PAYVCAT 상태 확인 응답',
    '0009': '가맹점 정보 확인 요청',
    '1009': '가맹점 정보 확인 응답',
};
/** 필터 선택지·정렬용 코드 목록 (선언 순서 = 화면 표시 순서) */
exports.TCP_SERVICE_CODES = Object.keys(exports.TCP_SERVICE_LABEL);
/**
 * 로그에 남은 서비스 코드의 한글 명칭 — 표에 없으면 `null`.
 *
 * `request_service_code`는 **상대가 보낸 바이트에서 나온다.** 미정의 코드(`14 UNKNOWN_SERVICE`)로
 * 거절한 전문도 그대로 기록되므로, 표에 없는 값이 실제로 들어온다. 그때 코드 자체를 라벨로
 * 되돌리면 화면에서 "정의된 전문"과 구분이 안 되니 없음을 없음으로 돌려준다.
 */
function tcpServiceLabel(code) {
    return code !== null && code in exports.TCP_SERVICE_LABEL
        ? exports.TCP_SERVICE_LABEL[code]
        : null;
}
/**
 * 조회 기본 기간 — **오늘(KST)에서 며칠 전까지 거슬러 여는가.** 1이면 어제 00:00 ~ 오늘 23:59.
 *
 * `comm_log`는 전문 왕복 한 번에 **1행**이지만 단말 10만 대 × 10건/일이면 하루치가 100만 행이라
 * 기본값을 넓게 두면 첫 화면부터 무거워진다. 진단은 대개 "방금 그 단말"을 보는 일이다.
 *
 * 0(오늘만)이 아닌 이유: 새벽에 열면 몇 분치만 보인다. 어젯밤 건이 기본 화면에서 빠지면
 * 사용자는 그 화면이 비어 있다고 읽는다.
 */
exports.COMM_LOG_DEFAULT_RANGE_DAYS = 1;
/**
 * 조회 기간 상한(일) — 넘으면 400.
 *
 * 무제한으로 열면 인덱스가 있어도 전 구간 스캔이 되고, 엑셀은 그 전량을 메모리에 올린다
 * (`sendXlsx`는 워크북을 통째로 만든다). 한 달치면 "지난달 그 사건"까지 닿으면서
 * 한 번에 뽑는 양이 예측 가능한 범위에 머문다.
 */
exports.COMM_LOG_MAX_RANGE_DAYS = 31;
/**
 * 통신 로그를 DB에 **그대로(Plain) 두는 일수** — 그보다 오래된 날짜는 하루 단위 gzip 파일로
 * Cloud Storage에 옮겨지고 DB에서 지워진다(2026-10-01 대표 확정 B안: Plain 1주 · 전체 보존 90일).
 *
 * 화면이 이 값 **밖**의 날짜를 조회하면 압축 파일을 풀어 읽는 비동기 작업 경로를 탄다. 서버 env
 * `COMM_LOG_PLAIN_DAYS`의 기본값과 **같은 값이어야 한다** — 서버가 env로 바꾸면 화면은
 * `GET /comm-logs/archive-info`로 실제 값을 받아 쓰고, 이 상수는 그 응답이 오기
 * 전의 기본값이다.
 */
exports.COMM_LOG_PLAIN_DAYS = 7;
exports.COMM_LOG_SEARCH_STATUS_LABEL = {
    QUEUED: '대기 중',
    RUNNING: '조회 중',
    DONE: '완료',
    FAILED: '실패',
    CANCELLED: '취소됨',
    TOO_MANY: '결과가 너무 많음',
};
/**
 * 작업 결과 상한(행). 넘으면 `TOO_MANY` — 결과는 메모리(작업 캐시)에 있고 이 프로세스는 Pay Vcat TCP
 * 리스너를 함께 든 e2-small이라, 상한 없이 쌓으면 조회 한 번이 단말 통신을 흔든다.
 */
exports.COMM_LOG_SEARCH_MAX_ROWS = 20_000;
